// CustomDateSeparator.js
import React from 'react';
import { format } from 'date-fns';

const CustomDateSeparator = ({ date }) => {
  const formattedDate = format(new Date(date), 'MMMM d, yyyy'); // e.g. April 15, 2025

  return (
    <div style={{ textAlign: 'center', margin: '10px 0', color: '#888' }}>
      {formattedDate}
    </div>
  );
};

export default CustomDateSeparator;
